import discardSurfaceActionsOption from './actions/discardSurfaceActionsOption';
import saveSurfaceActionsOption from './actions/saveSurfaceActionsOption';
import MailSurfaceActions from './components/MailSurfaceActions';
import isSurfaceActionsOptionDirty from './utils/isSurfaceActionsOptionDirty';
import * as React from 'react';
var ComposeSurfaceActionsOption = {
    key: 'composeSurfaceActions',
    titleStringKey: 'optionTitle_composeSurfaceActions',
    searchTermsStringKey: 'optionTitle_composeSurfaceActions',
    fullOptionFormSettings: {
        render: function () { return React.createElement(MailSurfaceActions, { isCompose: true }); },
        isDirty: isSurfaceActionsOptionDirty,
        onSave: saveSurfaceActionsOption,
        onDiscard: discardSurfaceActionsOption,
    },
};
export default ComposeSurfaceActionsOption;
//# sourceMappingURL=ComposeSurfaceActionsOption.js.map